export const currencyFormatter = new Intl.NumberFormat("fr", {
  style: "currency",
  currency: "EUR",
});
